import { translationSolutions_da } from "./translationSolutions.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationSolutions_en } from "./translationSolutions.en";
import { translationSolutions_sv } from "./translationSolutions.sv";

export const translationSolutions = defineDashboardTranslations({
  da: translationSolutions_da,
  en: translationSolutions_en,
  sv: translationSolutions_sv,
});
